var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 18.2c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2c.7 0 1.2.6 1.2 1.2s-.5 1.2-1.2 1.2zm2-5.9c-.9 1-.9 1.5-.9 2.2h-2c0-1.5 0-2.1 1.4-3.5.6-.5 1-1 1-1.8-.1-.8-.8-1.2-1.5-1.2s-1.5.5-1.5 2h-2c0-2.4 1.4-4 3.6-4 1 0 1.9.3 2.6 1 .6.6.9 1.4.9 2.3-.1 1.4-1 2.3-1.6 3z"
  })));
}

export default SvgIconHelp;